import env from '../../../../../../../../env';

export default class AlMediaManagerDropZoneController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;
        this.usersStore = this.injector.get('Users');
        this.auth = this.injector.get('$auth');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.uploadHidden = false;
        this.directoryUuid = null;
        this.triggerFileSelection = null;
        this.allowedMimes = [];
        this.allowedTypes = [];

        this.dropZoneContainer = this.element.find('.dropzone-container');
        this.dropZoneInstance = null;

        this.currentState = 'ready';
        this.statusLabels = {
            ready: 'Drop file here',
            processing: '<i class="fal fa-sync fa-spin"></i>&nbsp;Uploading file',
            error: ''
        };

        this._resetUploadError();
    }

    $onInit() {
        this._initWatchers();

        if(!_.isUndefined(this.triggerFileSelection)) {
            this.triggerFileSelection = () => {
                this.dropZoneInstance.hiddenFileInput.click();
            }
        }
    }

    $postLink() {
        this._initializeDropZone();
    }

    $onDestroy() {
        this.dropZoneInstance.destroy();
    }

    // Private functions
    _initWatchers() {

    }

    _initializeDropZone() {
        this.dropZoneContainer.dropzone(this._getDropZoneConfig());
    }

    _getDropZoneConfig() {
        const translations = {},
            fieldsToTranslate = [
                'dictDefaultMessage',
                'dictFallbackMessage',
                'dictFallbackText',
                'dictFileTooBig',
                'dictInvalidFileType',
                'dictResponseError',
                'dictCancelUpload',
                'dictUploadCanceled',
                'dictCancelUploadConfirmation',
                'dictRemoveFile',
                'dictRemoveFileConfirmation',
                'dictMaxFilesExceeded',
                'dictFileSizeUnits.tb',
                'dictFileSizeUnits.gb',
                'dictFileSizeUnits.mb',
                'dictFileSizeUnits.kb',
                'dictFileSizeUnits.b'
            ];

        _.each(fieldsToTranslate, (keyPath) => {
            _.set(translations, keyPath, this._getTranslationValue(`dropZoneJSTranslations.${keyPath}`));
        });

        const controller = this;
        return {
            url: `${env.apiUrl}/media/files/upload`,
            paramName: 'file',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + this.auth.getToken()
            },
            init: function () {
                controller.initDropZoneEvents(this);
            },
            maxFiles: 2,
            maxFilesize: this._getMaxFileSize(),
            acceptedFiles: this._getAcceptedFileTypes(),
            params: this._getAdditionalParameters(),
            addRemoveLinks: false,
            createImageThumbnails: false,
            autoProcessQueue: true,
            previewTemplate: '<div class="dz-preview-entry"></div>',
            ...translations
        };
    }

    _getAdditionalParameters() {
        return {
            hidden: this.uploadHidden ? 1 : 0,
            directory_uuid: this.directoryUuid ? this.directoryUuid : ''
        };
    }

    _getMaxFileSize() {
        return _.get(this.usersStore.state.company, 'settings.media.allowed_file_size', 20 * 1024 * 1024);
    }

    _getAcceptedFileTypes() {
        if(_.isArray(this.allowedMimes) && this.allowedMimes.length > 0) {
            return this.allowedMimes;
        }

        return _.get(this.usersStore.state.company, 'settings.media.allowed_file_mimes', [
            'audio/aac',
            'application/x-abiword',
            'application/x-freearc',
            'video/x-msvideo',
            'application/vnd.amazon.ebook',
            'application/octet-stream',
            'image/bmp',
            'application/x-bzip',
            'application/x-bzip2',
            'text/csv',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-fontobject',
            'application/epub+zip',
            'application/gzip',
            'image/gif',
            'text/html',
            'image/vnd.microsoft.icon',
            'text/calendar',
            'application/java-archive',
            'image/jpeg',
            'application/json',
            'application/ld+json',
            'audio/midi audio/x-midi',
            'audio/mpeg',
            'video/mpeg',
            'application/vnd.apple.installer+xml',
            'application/vnd.oasis.opendocument.presentation',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.text',
            'audio/ogg',
            'video/ogg',
            'application/ogg',
            'audio/opus',
            'font/otf',
            'image/png',
            'application/pdf',
            'application/php',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.rar',
            'application/rtf',
            'image/svg+xml',
            'application/x-shockwave-flash',
            'application/x-tar',
            'image/tiff',
            'video/mp2t',
            'font/ttf',
            'text/plain',
            'application/vnd.visio',
            'audio/wav',
            'audio/webm',
            'video/webm',
            'image/webp',
            'font/woff',
            'font/woff2',
            'application/xhtml+xml',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/xml',
            'text/xml',
            'application/vnd.mozilla.xul+xml',
            'application/zip',
            'video/3gpp',
            'audio/3gpp',
            'video/3gpp2',
            'audio/3gpp2',
            'application/x-7z-compressed'
        ]).join(',');
    }

    initDropZoneEvents(dropZoneInstance) {
        dropZoneInstance.on("processing", (file) => {
            dropZoneInstance.options.params = this._getAdditionalParameters();
            this._resetUploadError();
            this._updateCurrentState('processing');
        });

        dropZoneInstance.on("error", (file, error, xhrRequest) => {
            if (this.onUploadError) {
                this.onUploadError({
                    file,
                    error,
                    xhrRequest
                });
            }
            if (_.isString(error)) {
                this._setUploadError(error);
            } else {
                this._setUploadError('An error occurred.');
                console.error('Dropzone upload error', {error, xhrRequest});
            }

            dropZoneInstance.removeFile(file);
            this._updateCurrentState('error');
        });

        dropZoneInstance.on("success", (fileObject, response) => {
            if (this.onUploadSuccess) {
                this.onUploadSuccess({
                    file: _.cloneDeep(response.data)
                });
            }
            this._updateCurrentState('ready');
        });

        this.dropZoneInstance = dropZoneInstance;
    }

    _getTranslationValue(path) {
        return this.translate.instant(`media.components.media-manager.${path}`);
    }

    _updateCurrentState(newState) {
        this.currentState = newState;
        this._updateScope();
    }

    _setUploadError(error) {
        this.statusLabels.error = error;
        this._updateScope();
    }

    _resetUploadError() {
        this.statusLabels.error = '';
        this._updateScope();
    }

    _updateScope() {
        this.scope.$applyAsync();
    }
}

AlMediaManagerDropZoneController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/drop-zone/controller.js